import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

type ModalKind = 'waitlist' | 'intake' | null;
type Ctx = { open: ModalKind; setOpen: (k: ModalKind) => void };

const ModalCtx = createContext<Ctx>({ open: null, setOpen: () => {} });

export function ModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState<ModalKind>(null);

  // Esc closes any open modal.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(null); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return <ModalCtx.Provider value={{ open, setOpen }}>{children}</ModalCtx.Provider>;
}

export const useModal = () => useContext(ModalCtx);
